import { Component, Injectable, OnInit, TemplateRef } from '@angular/core';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';

import * as _ from 'lodash';
import { IvrService } from '../../../../../common/services/Ivr.service';
import { UploadService } from '../../../../../common/services/Upload.service';
import { CommonService } from '../../../../../common/services/Common.service';
import { moment } from 'ngx-bootstrap/chronos/test/chain';


declare var $: any;

@Component({
    moduleId: module.id,
    selector: "ivr",
    templateUrl: './ivr.component.html',
    styleUrls: ['./ivr.css'],
    providers: [IvrService, BsModalService, UploadService, CommonService]
})

@Injectable()
export class IvrComponent implements OnInit {
    public dtOptions: any = {};
    public dtTrigger: Subject<any> = new Subject();

    public currentPage: number = 1;
    public totalRow: number = 0;
    public page_size: number = 10;
    public message: { class: string, content: string } = null;
    public change_message: any = [];
    public list: any = [];
    public listState: any = [];
    public listStateType: any = [{ id: '', text: '' }];
    public selectListState: any = [{ id: '', text: '' }];
    public model: any = {};
    public modelFilter: any = {};
    public typeModal: string;
    public modalRef: any = {};
    public modalRef2: any = {};
    totalItem: any = 0;
    totalPage: any = 0;
    public is_detail: boolean = false;
    public current_cp: any;
    public open_form_state: boolean = false;
    public form_state_type: string = 'add';
    public current_state: any = {};
    public is_load_data: any = false;

    public user: any;

    public id_delete: number;
    public index_change_delete : number;

    public show_change : any = {};
    public list_change : any = [];
    public index_change : number = 100;

    constructor(
        private ivrService: IvrService,
        private modalService: BsModalService,
        private uploadService: UploadService,
        private commonService: CommonService,
        private toastr: ToastrService) {

        this.user = JSON.parse(localStorage.getItem('User'));
    }

    ngOnInit() {
        this.loadCp()
    }

    loadCp(request: any = {}, sort: any = {}) {
        request.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
        request.limit = this.page_size;
        if (Object.keys(sort).length == 2) {
            request['sort_by'] = sort.field + ':' + sort.typeSort
        }
        this.ivrService.listCP(request).subscribe(res => {
            if (!res.error && res.status == 200) {
                this.list = res.data.ivr_cp;
                this.totalItem = res.data.total;
                var pageString = (this.totalItem / this.page_size).toString();
                var pageSplit = pageString.split('.');
                var last: any;
                var totalpage = parseInt(pageSplit[0]);
                if (pageSplit.length > 1) {
                    last = pageSplit[1];
                    if (parseInt(last) > 0) {
                        totalpage++
                    }
                }
                this.totalPage = totalpage;
            }
        })
    }

    loadState(cp) {
        this.is_load_data = true;
        this.ivrService.listState(this.current_cp.CP_ID).subscribe(res => {
            if (!res.error && res.status == 200) {
                let tmp_list = [{ id: '', text: '' }]
                this.listState = res.data;
                this.listState.forEach(e => {
                    tmp_list.push({
                        id: e.STATE_ID,
                        text: e.DESCRIPTION
                    })
                });
                this.selectListState = tmp_list;
                setTimeout(() => {
                    this.is_load_data = false;
                }, 500);
            }
        })
    }

    detailCp(cp) {
        this.is_load_data = true;
        this.change_message = [];
        this.is_detail = true;
        this.current_cp = cp;
        this.loadState(this.current_cp);
        this.index_change = 100;  
        this.list_change = [];
        this.show_change= {};
        this.open_form_state = false;
        this.ivrService.listChange({CP_ID: this.current_cp.CP_ID}).subscribe(res => {
            let data = res.data ? res.data  : [];
            let _idx = 0;
            for(var i = 0 ; i < 101; i++) {
                this.list_change.push({
                    STATE_ID1 : null,
                    INPUT: null,
                    STATE_ID2 : null
                })
            }
        
            this.show_change[100] = true;
            data.forEach(e => {
                this.list_change[this.index_change] = e;
                this.show_change[this.index_change] = true;
                this.index_change = this.index_change - 1;
            });
            setTimeout(() => {
                this.is_load_data = false;
            }, 500);
        })
    }

    addNewChange() {
        this.index_change = this.index_change - 1;
        this.show_change[this.index_change] = true;
    }

    deleteChange(index) {
        var y = confirm("Bạn muốn xóa liên kết này không?");
        if(y){
            if(this.list_change[index].ID){
                this.index_change_delete = index;
                this.submitDeleteChange();
            } else {
                this.show_change[index] = false;
            }
            
        }
        
    }

    choiceState(event,index,order) {
        if(!this.is_load_data){
            if(order == 1) {
                this.list_change[index]['STATE_ID1'] = event.value;
            }else {
                this.list_change[index]['STATE_ID2'] = event.value;
            }
        }
        
    }
    
    openConfirmDeleteChange(template: TemplateRef<any>, index) {
        this.index_change_delete = index;
        // this.modalRef2 = this.modalService.show(template);
        var y = confirm("Bạn có muốn xóa không?");
        if(y){
            this.submitDeleteChange();
        }
    }

    submitDeleteChange() {
        let id_change = this.list_change[this.index_change_delete].ID;
        this.ivrService.deleteChange(id_change).subscribe(res => {
            if (res) {
                let error = res.error;
                if (error) {
                    this.toastr.error('Xóa không thành công', '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                } else {
                    this.toastr.success('Xóa thành công', '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                    this.show_change[this.index_change_delete] = false;
                    // this.modalRef2.hide();
                }
            }
        }, error => {
            this.message = { class: "alert dark alert-danger", content: error.message };
        });

    }

    submitDeleteState(id) {
        let flag = false;
        for(let i=0; i<this.list_change.length; i++){
            if(this.list_change[i].STATE_ID1 == id || this.list_change[i].STATE_ID2 == id){
                flag = true;
                break;
            }
        }
        if(!flag){
            var y = confirm("Bạn có muốn xóa trạng thái này không?");
            if(y){
                this.ivrService.deleteState(id).subscribe(res => {
                    if (res) {
                        let error = res.error;
                        if (error) {
                            this.toastr.error('Xóa không thành công', '', {
                                timeOut: 4000,
                                positionClass: 'toast-bottom-right'
                            });
                        } else {
                            this.toastr.success('Xóa thành công', '', {
                                timeOut: 4000,
                                positionClass: 'toast-bottom-right'
                            });
                            this.loadState(this.current_cp);
                            // this.modalRef2.hide();
                        }
                    }
                }, error => {
                    this.message = { class: "alert dark alert-danger", content: error.message };
                });
        
            }
        } else {
            this.toastr.error('Trạng thái đang được liên kết, không thể xóa', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
        }
    }

    saveChange(index) {
        let payload = _.assign({},this.list_change[index]);
        payload['CP_ID'] = this.current_cp.CP_ID;
        // if(payload['STATE_ID1']) payload['STATE_ID1'] = payload['STATE_ID1'].trim();
        // if(payload['STATE_ID2']) payload['STATE_ID2'] = payload['STATE_ID2'].trim();
        if(payload['INPUT']) payload['INPUT'] = payload['INPUT'].trim();
        if (!payload.STATE_ID1) {
            this.change_message[index] = { class: "alert dark alert-danger", content: "State 1 không được bỏ trống !" };
        } else if (!payload.STATE_ID2) {
            this.change_message[index] = { class: "alert dark alert-danger", content: "State 2 không được bỏ trống !" };
        }else if(!payload.INPUT || (payload.INPUT && payload.INPUT.trim() == "")) {
            this.change_message[index] = { class: "alert dark alert-danger", content: "Ký tự liên kết không được bỏ trống !" };
        }else if(payload.STATE_ID1 == payload.STATE_ID2) {
            this.change_message[index] = { class: "alert dark alert-danger", content: "State 1 trùng State 2" };
        }else {
            if(payload.ID) {
                let data_update = _.assign({}, payload);
                let change_id = payload.ID;
                delete payload.ID;
                //update
                this.ivrService.updateChange(change_id, data_update).subscribe(res => {
                    if (res) {
                        let error = res.error;
                        if (error) {
                            this.toastr.error('Cập nhật thất bại', '', {
                                timeOut: 4000,
                                positionClass: 'toast-bottom-right'
                            });
                        } else {
                            this.toastr.success('Cập nhật thành công', '', {
                                timeOut: 4000,
                                positionClass: 'toast-bottom-right'
                            });
                            this.change_message[index] = null;
                        }
                    }
                }, error => {
                    this.message = { class: "alert dark alert-danger", content: error.message };
                });
            }else {
                this.ivrService.createChange(payload).subscribe(res => {
                    if (res) {
                        let error = res.error;
                        if (error) {
                            this.toastr.error('Thêm mới thất bại', '', {
                                timeOut: 4000,
                                positionClass: 'toast-bottom-right'
                            });
                        } else {
                            this.toastr.success('Thêm mới thành công', '', {
                                timeOut: 4000,
                                positionClass: 'toast-bottom-right'
                            });
    
                            this.list_change[index]['ID'] = res.data[0];
                            this.change_message[index] = null;
                        }
                    }
                }, error => {
                    this.toastr.error('Thêm mới thất bại', '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                });
            }
        }
        
    }

    openFormState(state) {
        this.message = null;
        this.open_form_state = true;
        this.getStateTypes();
        if (state) {
            this.form_state_type = 'edit';
            this.current_state = state;
        } else {
            this.current_state = {};
            this.form_state_type = 'add';
        }

    }

    changedStateType(event) {
        if(!this.is_load_data){
            this.current_state['TYPE'] = event.value;
        }
        
    }

    changeNextState(event) {
        this.current_state['DEFAULT_NEXT_STATE'] = event.value;
    }

    changeFile($event, is_first) {
        if($event.target.value.length != 0){
            var files = $event.srcElement.files;
            let typeFile = files[0]? files[0].type : null;
            if(typeFile && !typeFile.includes('audio')) {
                this.toastr.error('Định dạng file là file âm thanh (mp3,wav..)', '', {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right'
                });
            }else {
                this.uploadService.upload(files[0]).then((res: any) => {
                    if (!res.error) {
                        if (is_first) {
                            this.current_state['FIRST_FILE'] = this.commonService.file(res.data);
                        } else {
                            this.current_state['SECOND_FILE'] = this.commonService.file(res.data);
                        }
                        $event.target.value = null;
                    } else {
                        this.toastr.error(res.data.message, 'Lỗi', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                    }
                })
            }
        }
        else {
            if(is_first){
                this.current_state['FIRST_FILE'] = null;
            } else {
                this.current_state['SECOND_FILE'] = null;
            }
        }
        
    }

    saveState() {
        // if (!this.current_state.TYPE){
        //     this.message = { class: "alert dark alert-danger", content: "Loại STATE không được bỏ trống !" };
        // }else if(!this.current_state.DESCRIPTION) {
        //     this.message = { class: "alert dark alert-danger", content: "Mô tả không được bỏ trống" };
        // }else {
            this.current_state['CP_ID'] = this.current_cp.CP_ID;
            this.current_state['LAST_MODIFY'] = moment().valueOf();
            if(this.form_state_type == 'edit') {
                let state_id = parseInt(this.current_state.STATE_ID);
                let payload = _.assign({}, this.current_state);
                delete payload.STATE_ID;
                this.ivrService.updateState(state_id, payload).subscribe(res => {
                    if (res) {
                        let error = res.error;
                        if (error) {
                            this.message = { class: "alert dark alert-danger", content: "Cập nhật không thành công" };
                            this.toastr.error('Cập nhật thất bại', '', {
                                timeOut: 4000,
                                positionClass: 'toast-bottom-right'
                            });
                        } else {
                            this.message = { class: "alert dark alert-success", content: "Cập nhật thành công" };
                            this.toastr.success('Cập nhật thành công', '', {
                                timeOut: 4000,
                                positionClass: 'toast-bottom-right'
                            });
                            this.loadState(this.current_cp);
                            this.detailCp(this.current_cp);
                            this.backToListState();
                        }
                    }
                }, error => {
                    this.message = { class: "alert dark alert-danger", content: error.message };
                });
            }else {
                this.ivrService.createState(this.current_state).subscribe(res => {
                    if (res) {
                        let error = res.error;
                        if (error) {
                            this.message = { class: "alert dark alert-danger", content: "Thêm mới không thành công" };
                            this.toastr.error('Thêm mới thất bại', '', {
                                timeOut: 4000,
                                positionClass: 'toast-bottom-right'
                            });
                        } else {
                            this.message = { class: "alert dark alert-success", content: "Thêm mới thành công" };
                            this.toastr.success('Thêm mới thành công', '', {
                                timeOut: 4000,
                                positionClass: 'toast-bottom-right'
                            });
                            this.loadState(this.current_cp);
                            this.detailCp(this.current_cp);
                            this.backToListState();
                        }
                    }
                }, error => {
                    this.message = { class: "alert dark alert-danger", content: error.message };
                });
            }
        // }
    }

    backToListState() {
        this.open_form_state = false;
    }

    getStateTypes() {
        this.is_load_data = true;
        this.ivrService.stateTypes().subscribe(res => {
            let typeList = [{ id: '', text: '' }];
            res.data.forEach(e => {
                typeList.push({
                    id: e.id,
                    text: e.state_type_name
                })
            });
            this.listStateType = typeList;
            setTimeout(() => {
                this.is_load_data = false;
            }, 1000);
        })

    }

    setPage(page: number) {
        if (page <= this.totalPage) {
            if (page < 1) {
                page = 1;
            }
            if (page != this.currentPage) {
                this.currentPage = page;
                this.loadCp();
            }
        }
        else {

            page = this.totalPage;
            $('#inputPage').val(page);
            this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
            if (page <= this.totalPage) {
                //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
                if (page < 1) {
                    page = 1;
                }
                if (page != this.currentPage) {
                    this.currentPage = page;
                    this.loadCp();
                }
            }
        }
    }
    goPage2(toPage: any) {
        toPage = parseInt(toPage);
        if (toPage && toPage > 0) {
            this.setPage(toPage);
        }
    }

    openModal(template: TemplateRef<any>, id?: any) {
        this.message = null;
        let config = {
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false
        }
        this.modalRef = this.modalService.show(template, config);

        this.model = {};
        this.typeModal = id ? 'edit' : 'add'

        if (id) {
            this.ivrService.detailCP(id).toPromise().then(rs => {
                this.model = rs.data;
            })
        }
    }

    openConfirmDelete(template: TemplateRef<any>, id) {
        this.id_delete = id;
        // this.modalRef2 = this.modalService.show(template);
        var y = confirm("Bạn có muốn xóa không?");
        if(y){
            this.submitDelete();
        }
    }

    addCp() {
        // if (!this.model.NAME || (this.model.NAME && this.model.NAME.trim() == ""))
        //     this.message = { class: "alert dark alert-danger", content: "Tên không được bỏ trống !" };
        // else if (!this.model.RULE || (this.model.RULE && this.model.RULE.trim() == "")) {
        //     this.message = { class: "alert dark alert-danger", content: "Đầu số không được bỏ trống !" };
        // } else {
            if(this.model.NAME) this.model.NAME = this.model.NAME.trim();
            if(this.model.RULE) this.model.RULE = this.model.RULE.trim();
            this.ivrService.createCP(this.model).subscribe(res => {
                if (res) {
                    let error = res.error;
                    if (error) {
                        this.message = { class: "alert dark alert-danger", content: "Thêm mới không thành công" };
                        this.toastr.error('Thêm mới thất bại', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                    } else {
                        this.message = { class: "alert dark alert-success", content: "Thêm mới thành công" };
                        this.toastr.success('Thêm mới thành công', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });

                        this.loadCp();
                        this.modalRef.hide();
                    }
                }
            }, error => {
                this.message = { class: "alert dark alert-danger", content: error.message };
            });
        // }
    }

    editCp() {
        this.message = null

        // if (!this.model.NAME || (this.model.NAME && this.model.NAME.trim() == ""))
        //     this.message = { class: "alert dark alert-danger", content: "Tên không được bỏ trống !" };
        // else if (!this.model.RULE || (this.model.RULE && this.model.RULE.trim() == "")) {
        //     this.message = { class: "alert dark alert-danger", content: "Đầu số không được bỏ trống !" };
        // } else {
            let payload = {};
            if (this.model.NAME) payload['NAME'] = this.model.NAME.trim();
            if (this.model.RULE) payload['RULE'] = this.model.RULE.trim();

            this.ivrService.updateCP(this.model.CP_ID, payload).subscribe(res => {
                if (res) {
                    let error = res.error;
                    if (error) {
                        this.message = { class: "alert dark alert-danger", content: "Cập nhật không thành công" };
                        this.toastr.error('Cập nhật thất bại', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                    } else {
                        this.message = { class: "alert dark alert-success", content: "Cập nhật thành công" };
                        this.toastr.success('Cập nhật thành công', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                        this.loadCp();
                        this.modalRef.hide();
                    }
                }
            }, error => {
                this.message = { class: "alert dark alert-danger", content: error.message };
            });
        // }
    }

    submitDelete() {
        this.ivrService.deleteCP(this.id_delete).subscribe(res => {
            if (res) {
                let error = res.error;
                if (error) {
                    this.toastr.error('Xóa không thành công', '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                } else {
                    this.toastr.success('Xóa thành công', '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                    this.loadCp();
                    // this.modalRef2.hide();
                }
            }
        }, error => {
            this.message = { class: "alert dark alert-danger", content: error.message };
        });
    }
}




// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/pages/admin/icontact/setting/ivr/ivr.component.ts